<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="title-big">
            <h1>Hello</h1>
        </div>
        <div class="title-text">
            欢迎来到爱驿站 {{ stationName }}
        </div>
        <div class="title-text">
            您前面还有 <span style="color: #FE405F"> {{waiting}} </span> 位顾客在等待
        </div>

        <div class="mobile-input">
            <input class="phone" v-model="mobile" type="number" name="phone" placeholder="请输入手机号">
        </div>

        <div class="code-input">
            <input class="code" type="number" name="code" v-model="code" placeholder="请输入验证码">
            <span v-if="timerActive" @click="onSendCode">{{ timeRemaining }}秒后重发</span>
            <span v-else @click="onSendCode">发送验证码</span>
        </div>

        <div class="reload-btn" @click="onApplyCall">
            叫号
        </div>

        <div class="footer">
            <p>江苏爱驿站信息科技有限公司</p>
            <p>Copyright © 2014-2025 Aiyizhan All Rights Reserved</p>
        </div>


    </div>
</template>

<script>

import {verifyPhone} from "@/assets/js/common";
import {showFailToast} from "vant";
import ayzAjax from "@/plugins/axios";

export default {
    name: "ReloadView",
    data: function () {
        return {
            stationName:'',
            waiting:0,
            mobile:'',
            code:'',
            codeMsg:'发送验证码',
            timerActive: false,
            timeRemaining: 60,
            station:null,
        }
    },
    created() {
        this.onGetQueueingInfo();
    },
    methods: {
        onSendCode(){
            if(!verifyPhone(this.mobile)){
                return showFailToast('手机号格式不正确!');
            }
            if (this.timeRemaining > 0 && this.timeRemaining !== 60) {
                return false;
            }
            this.timerActive = true;
            this.interval = setInterval(() => {
                if (this.timeRemaining > 0) {
                    this.timeRemaining--;
                } else {
                    this.timerActive = false;
                    this.timeRemaining = 60;
                    clearInterval(this.interval);
                }
            }, 1000);

            console.log(this.mobile)
        },
        onApplyCall(){
            if(!verifyPhone(this.mobile)){
                return showFailToast('手机号格式不正确!');
            }
            if (this.code.length < 4) {
                return showFailToast('验证码错误!');
            }
            let fromData = {};
            fromData.mobile = this.mobile;
            fromData.verify_code = this.code;
            fromData.station_id = this.station.id;

            ayzAjax.post('/call/enqueue',fromData).then((response) => {
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg)
                }
                localStorage.setItem('callTicket', JSON.stringify(response.data.data));
                this.$router.push({ path: '/call/cancel'});
            })
            console.log('叫号')
        },

        onGetQueueingInfo(){

            this.station = JSON.parse(localStorage.getItem('station'));
            this.stationName = this.station.title;
            let fromData = {};
            fromData.station_id = this.station.id;
            ayzAjax.post('/call/queueing_count_in_station',fromData).then((response) => {
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg)
                }
                this.waiting = response.data.data.count;
            })
        },

    }
}
</script>

<style lang="scss" scoped>

.reload-view{
    //width: 100%;
    background-color: #FFFFFF;
    text-align: left;
    padding: 40px 30px 0 30px;
    .title-big{
        margin: 10px 10px 40px 10px;
    }
    .title-text{
        margin: 20px 10px 0 10px;
        font-weight: 550;
        font-size: 15px;
    }
    .mobile-input{
        //width: 100%;
        margin-top: 80px;
        height: 50px;
        background-color: #F7F8FA;
        line-height: 50px;
        padding-left: 10px;
        border-radius: 15px;
        .phone{
            //width: 100%;
            background-color: #F7F8FA;
            border: 0;
            border-radius: 15px;
        }
    }
    .code-input{
        display: flex;
        //width: 100%;
        margin-top: 20px;
        height: 50px;
        background-color: #F7F8FA;
        line-height: 50px;
        padding-left: 10px;
        border-radius: 15px;
        .code{
            background-color: #F7F8FA;
            border: 0;
            border-radius: 15px;
        }
    }
    .reload-btn{
        margin-top: 80px;
        height: 60px;
        line-height: 60px;
        background-color: #FE405F;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
    .footer{
        margin-top: 120px;
        padding-bottom: 20px;
        text-align: center;
        color: #A5A5A5;
        font-weight: 300;
        font-size: 13px;
    }
}
</style>
